import {Routes} from '@angular/router';

export const cashbackCashRoutes: Routes = [
  {
    path: 'cashback.cash',
    loadComponent: () => import('./cashback.cash.component').then(m => m.CashbackCashComponent),
    data: {title: '权益返利兑付'},
    children:[
      {
        path: '',
        loadComponent: () => import('./cash.order/cash.order.component').then(m => m.CashOrderComponent),
      },
      {
        path: 'add.equity.cash',
        loadComponent: () => import('./add.equity.cash/add.equity.cash.component').then(m => m.AddEquityCashComponent),
        data: { title: '权益返利兑付明细' },
      },
      {
        path: 'add.equity.cash/:orderId',
        loadComponent: () => import('./add.equity.cash/add.equity.cash.component').then(m => m.AddEquityCashComponent),
        data: { title: '权益返利兑付明细' },
      },
    ]
  },
]
